import React from 'react'
import { useDispatch } from 'react-redux'
import { redirect } from 'redux-first-router'

export const Redirect = ({ action }) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!action) return

    dispatch(redirect(action()))
  }, [action, dispatch])

  return null
}
